<template>
    <b-col cols="12" lg="12" xl="12">
        <b-row> 
            <b-form-group class="col col-8 col-sm-6 col-lg-4 ps-0 pe-1 ccl-newpoll-number-input" >
                <label class="d-block" :for="`candidate-name-${index}`">{{candidateNameLabel}}</label>
                <b-input-group class="mb-2 me-sm-2 mb-sm-0 text-left" :class="borderClass(isValidName)" >
                    <b-input 
                        :id="`candidate-name-${index}`"
                        :disabled="disableForm"
                        :value="candidateName"
                        @input="$emit('update:candidateName',$event)"
                    >
                    </b-input>
                </b-input-group>
                <div v-if="!isValidName" class="text-center" style="width:100%;">
                    <p class="alert alert-danger text-danger fst-italic p-1 mx-0 mb-0 mt-3">Enter a valid candidate</p>
                </div>
            </b-form-group>
            <b-form-group class="col col-4 col-sm-3 col-lg-2 ps-0 pe-1 ccl-newpoll-number-input" role="named-group">
                <label class="d-block" :for="`candidate-percentage-${index}`">Percentage</label>
                <b-input-group append="%" class="mb-2 me-sm-2 mb-sm-0 text-right" :class="borderClass(isValidPercentage)" >
                    <b-input
                        :id="`candidate-percentage-${index}`"
                        type="number"
                        :value="percentage"
                        :disabled="disableForm"
                        @input="$emit('update:percentage', parseInt($event, 10))"
                        placeholder=""></b-input>
                </b-input-group>
                <div v-if="!isValidPercentage" class="text-center" style="width:100%;">
                    <p class="alert alert-danger text-danger fst-italic p-1 mx-0 mb-0 mt-3">Enter a percentage greater than or equal to 0</p>
                </div>
            </b-form-group>
        </b-row>
    </b-col>
</template>

<script setup>
    import { onMounted, computed, ref } from 'vue';
    
    const isValidName = computed(() => {
        if (!props.candidateName.match(/^\s+$/i) || props.candidateName === '') {
            return true;
        }
        return false;
    });
    const isValidPercentage = computed(() => {
        if (props.percentage >= 0 ||
            props.percentage === undefined ||
            isNaN(props.percentage) ||
            props.percentage === '')
            return true;
    });
    

    function borderClass( state ) {
                return (state ? '' : 'border border-danger ');
    };

    const props = defineProps({
        index: {required: true, type: Number},
        candidateNameLabel: {required: true, type: String},
        candidateName: {required: true, type: String},
        percentage: {required: true, type: [Number, String]},
        disableForm: {required: false, default:false, type: Boolean},
    });
</script>

<style>

</style>
